export default __webpack_public_path__ + "static/media/featSportBgMb.c68874a0.png";